/**
 * Get supported billing countries from merchant config's billing constraints
 *  - billingConstraints is an optional field in merchant config
 * @param {object} response
 * @returns {array} supported billing countries
 */
const getBillingCountries = response => {
  const acceptedRegions =
    response?.data?.merchantConfig?.billingConstraints?.acceptedRegions?.region ?? [];
  const billingCountries =
    (acceptedRegions.length > 0 && acceptedRegions.map(bRegion => bRegion.countryCode)) || [];
  return billingCountries;
};

export default getBillingCountries;
